module.exports = __webpack_public_path__ + "img/video3.2f50deb9.png";